import React from 'react';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

const NewPluginButton = (props) => {
    const { openAddModalBehavior } = props;

    const CreateNewPlugin = () => {
        openAddModalBehavior();
    };

    return (
        <div className="input-group">
            <Button className="m-2" color="info" onClick={CreateNewPlugin}>
                <FontAwesomeIcon icon={faPlus} />
                &emsp;Add New Plugin
            </Button>
        </div>
    );
};

export default NewPluginButton;
